// src/pages/Admin/LeadsTableAdmin.js
import React, { useEffect, useMemo, useCallback, useState } from "react";
import { useSnackbar } from "notistack";

import { HeaderPage } from "../../components/Admin";
import { DialogBasic, ModalBasic } from "../../components/common";

import { TableLeads } from "../../components/Admin/Leads/TableLeads";
import { LeadForm } from "../../components/Admin/Leads/LeadForm";

import { useLeads } from "../../hook/useLeads";
import { useLeadMeta } from "../../hook/useLeadMeta";

export function LeadsTableAdmin() {
  const { enqueueSnackbar } = useSnackbar();
  const { loading, leads, fetchLeads, removeLead } = useLeads();
  const { stages, sources, fetchMeta } = useLeadMeta();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [contentModal, setContentModal] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [leadToDelete, setLeadToDelete] = useState(null);

  const openCloseModal = () => setShowModal((p) => !p);

  useEffect(() => {
    fetchMeta();
    
  }, [fetchMeta]);

  useEffect(() => {
  fetchLeads({ ordering: "-created_at" });
}, [fetchLeads]);



  const addLead = () => {
    setTitleModal("Nuevo Lead");
    setContentModal(
      <LeadForm
        onClose={openCloseModal}
        onSaved={() => {
          enqueueSnackbar("Lead creado", { variant: "success" });
          // recarga con los últimos params que la tabla haya emitido (mejor)
          // por ahora, solo refresca ordenado:
          fetchLeads({ ordering: "-created_at" });
        }}
      />
    );
    openCloseModal();
  };

  const editLead = (lead) => {
    setTitleModal(`Editar Lead #${lead.id}`);
    setContentModal(
      <LeadForm
        lead={lead}
        onClose={openCloseModal}
        onSaved={() => {
          enqueueSnackbar("Lead actualizado", { variant: "success" });
          fetchLeads({ ordering: "-created_at" });
        }}
      />
    );
    openCloseModal();
  };

  const onDeleteLead = (lead) => {
    setLeadToDelete(lead);
    setOpenDialog(true);
  };

  const handleCloseDialog = async (confirmed) => {
    if (!confirmed) {
      setOpenDialog(false);
      setLeadToDelete(null);
      return;
    }

    try {
      await removeLead(leadToDelete.id);
      enqueueSnackbar("Lead eliminado", { variant: "success" });
      fetchLeads({ ordering: "-created_at" });
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Error eliminando lead", { variant: "error" });
    } finally {
      setOpenDialog(false);
      setLeadToDelete(null);
    }
  };

  return (
    <>
      <HeaderPage title="Leads (Tabla)" btnTitle="Nuevo Lead" btnClick={addLead} />

      {loading && <p>Cargando...</p>}

      <TableLeads
        leads={leads}
        stages={stages}
        sources={sources}
        onEdit={editLead}
        onDelete={onDeleteLead}
        onFiltersChange={(params) => fetchLeads(params)}
      />


      <ModalBasic show={showModal} onClose={openCloseModal} title={titleModal} sizeModal="medium">
        {contentModal}
      </ModalBasic>

      <DialogBasic open={openDialog} onClose={handleCloseDialog} />
    </>
  );
}
